import { render, staticRenderFns } from "./MarshalInfo.vue?vue&type=template&id=2eca223e&scoped=true"
import script from "./MarshalInfo.vue?vue&type=script&lang=js"
export * from "./MarshalInfo.vue?vue&type=script&lang=js"
import style0 from "./MarshalInfo.vue?vue&type=style&index=0&id=2eca223e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eca223e",
  null
  
)

export default component.exports